import { CURRENCIES } from '@savgroup-front-common/constants';

export interface ReverseMoney {
  amount: string;
  currency: CURRENCIES;
}

export interface ReverseMoneyNumberAmount {
  amount: number;
  currency: CURRENCIES;
}

export function determineReverseMoneyNumberAmount(
  toBeDetermined: ReverseMoneyNumberAmount | number,
): toBeDetermined is ReverseMoneyNumberAmount {
  return typeof toBeDetermined !== 'number';
}
